module.exports = __webpack_public_path__ + "images/mobile/icon-connect-arrow-98de18ae9e471ff13059fa5b8bae5c2b.png";